import { useAuth0 } from "@auth0/auth0-react";
// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Pro React components
import SoftBox from "components/SoftBox";

//New user component
import FormField from "layouts/pages/home/components/Settings/components/FormField";

import ProtectedButton from "authentication/ProtectedButton";
import { PERMISSIONS } from "constants/portal";
import { useIsOwner } from "hooks/useIsOwner";

function ProfileInfo({ formData }) {
  const { formField, values, errors, touched, roleOptions, setFieldValue } = formData;
  const {
    firstName,
    lastName,
    organization,
    email,
    mobile,
    phone,
    roleId,
    yourLocation,
    language
  } = formField;

  const selectedRole = roleOptions?.find((option) => option.value === values.role_id);

  const roleLabel = selectedRole?.label || "Select Role";

  const { user } = useAuth0();
  const isOwner = useIsOwner();

  const canEditRole = isOwner || user?.permissions?.includes(PERMISSIONS.ASSIGN_ROLE);
  
  return (
    <SoftBox>
      <Grid container sx={{ height: "100%" }} spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={firstName.type}
            label="First name"
            name={firstName.name}
            value={values.first_name}
            error={errors[firstName.name] && touched[firstName.name]}
            // success={!errors[firstName.name] && touched[firstName.name]}
            placeholder={firstName.placeholder ? firstName.placeholder : ""}
            forWhat="Profile Info"
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={lastName.type}
            label="Last name"
            name={lastName.name}
            value={values.last_name}
            error={errors[lastName.name] && touched[lastName.name]}
            // success={!errors[lastName.name] && touched[lastName.name]}
            placeholder={lastName.placeholder ? lastName.placeholder : ""}
            forWhat="Profile Info"
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={organization.type}
            label="Organization"
            name={organization.name}
            value={values.organization}
            // success={!errors[organization.name] && touched[organization.name]}
            placeholder={organization.placeholder ? organization.placeholder : ""}
            forWhat="Profile Info"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={email.type}
            label="Email"
            name={email.name}
            value={values.email_address}
            placeholder={email.placeholder ? email.placeholder : ""}
            error={errors[email.name] && touched[email.name]}
            // success={!errors[email.name] && touched[email.name]}
            forWhat="Profile Info"
            disabled={values.email_address ? true : false}
            readOnly={values.email_address ? true : false}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={phone.type}
            label="Phone"
            name={phone.name}
            pattern={phone.pattern}
            value={values.phone}
            // success={!errors[phone.name] && touched[phone.name]}
            error={errors.phone && touched.phone}
            placeholder={phone.placeholder ? phone.placeholder : ""}
            forWhat="Profile Info"
            forPhone
            setFieldValue={setFieldValue}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={mobile.type}
            label="Mobile"
            name={mobile.name}
            value={values.mobile || ""}
            error={errors[mobile.name] && touched[mobile.name]}
            placeholder={mobile.placeholder || ""}
            forWhat="Profile Info"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={yourLocation.type}
            label={yourLocation.label}
            name={yourLocation.name}
            value={values.your_location}
            placeholder={yourLocation.placeholder ? yourLocation.placeholder : ""}
            error={errors[yourLocation.name] && touched[yourLocation.name]}
            // success={!errors[yourLocation.name] && touched[yourLocation.name]}
            forWhat="Profile Info"
          />
        </Grid>
        <ProtectedButton permissionName={PERMISSIONS.ASSIGN_ROLE}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormField
              type={roleId.type}
              label={roleId.label}
              name={roleId.name}
              placeholder={roleId.placeholder ? roleId.placeholder : ""}
              defaultValue={{
                value: values.role_id,
                label: values.role_id ? roleLabel : "Select Role"
              }}
              options={roleOptions}
              isDisabled={!canEditRole}
            />
          </Grid>
        </ProtectedButton>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormField
            type={language.type}
            label={language.label}
            name={language.name}
            defaultValue={{
              value: values.language == " " ? "English" : values.language,
              label: values.language == " " ? "English" : values.language
            }}
            options={[{ value: "English", label: "English" }]}
            error={errors[language.name] && touched[language.name]}
            placeholder={language.placeholder ? language.placeholder : ""}
          />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default ProfileInfo;
